import { makeStyles } from '@material-ui/core/styles'
import { Button, Grid, useTheme } from '@material-ui/core'
import React from 'react'
import { Image, Transformation } from 'cloudinary-react'
import { CLOUDINARY_NAME } from '../../../constants'
import {
    CUSTOM_GREETING_CARDS,
    FREE_GIFT_CARDS,
    E_GIFT_CARDS,
    BUY_BULK_GIFT_CARDS,
} from '../../../routes'

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        justifyContent: 'center',
    },
    gridContainer: {
        width: '1440px',
        display: 'flex',
        justifyContent: 'center',
    },
    gridItem: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.up('md')]: {
            width: '350px',
            marginTop: '1.5rem',
        },
    },
    imgGrid: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.up('lg')]: {
            padding: '1.5rem',
        },
    },
    imgContainer: {
        textAlign: 'center',
        [theme.breakpoints.up('lg')]: {
            width: '40rem',
        },
        '& img': {
            width: '80%',
            maxWidth: '80%',
        },
    },
    textGrid: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        [theme.breakpoints.up('lg')]: {
            padding: '3rem',
        },
    },
    textContainer: {
        padding: '30px',
        [theme.breakpoints.up('sm')]: {
            width: '40rem',
        },
        [theme.breakpoints.up('lg')]: {
            width: '33rem',
            padding: '0',
        },
    },
    title: {
        marginTop: '-0.5rem',
        fontSize: '2rem',
        fontWeight: '700',
        [theme.breakpoints.up('lg')]: {
            width: '35rem',
        },
    },
    p: {
        fontSize: '18px',
        [theme.breakpoints.up('lg')]: {
            width: '35rem',
        },
    },
    buttonsContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
    },
    button: {
        color: theme.palette.primary.main,
        borderRadius: '5px',
        fontWeight: '700',
        padding: '10px 24px 10px 12px',
        border: `2px solid ${theme.palette.primary.main}`,
        background: 'white',
        marginTop: '.5rem',
        display: 'block',
        textTransform: 'none',
        textAlign: 'center',
        width: '15rem',
        [theme.breakpoints.up('md')]: {
            marginTop: '1.5rem',
        },
        '&:hover': {
            backgroundColor: 'white!important',
            color: `${theme.palette.primary.main}!important`,
        },
    },
}))

const CommittedSection = ({ baseUrl }) => {
    const classes = useStyles()
    const theme = useTheme()

    const allButtons = [
        {
            id: 1,
            name: 'Greeting cards',
            href: CUSTOM_GREETING_CARDS,
        },
        {
            id: 3,
            name: 'Cash back rewards',
            href: FREE_GIFT_CARDS,
        },
        {
            id: 4,
            name: 'Digital Gift cards',
            href: E_GIFT_CARDS,
        },
        {
            id: 5,
            name: 'Corporate & bulk rewards',
            href: BUY_BULK_GIFT_CARDS,
        },
    ]

    return (
        <div className={classes.container}>
            <Grid container className={classes.gridContainer}>
                <Grid item lg={6} className={classes.imgGrid}>
                    <div className={classes.imgContainer}>
                        <Image
                            cloudName={CLOUDINARY_NAME}
                            publicId={'GCG/legit_page/greeting_card_znjsj2'}
                            loading="lazy"
                            title={`Happy birthday card with Visa gift card`}
                            alt={`Happy birthday card with Visa gift card`}
                        >
                            <Transformation
                                width={'624'}
                                crop="scale"
                                fetchFormat="auto"
                            />
                        </Image>
                    </div>
                </Grid>
                <Grid item lg={6} className={classes.textGrid}>
                    <div className={classes.textContainer}>
                        <h3 className={classes.title}>
                            We're always innovating to make gifting easier and
                            more rewarding!
                        </h3>
                        <p className={classes.p}>
                            We're constantly adding new ways to save with Cash
                            Back Rewards and innovative features for the best
                            gifting experience, like our new handwritten
                            greeting cards for a truly personalized touch.
                        </p>
                        <div className={classes.buttonsContainer}>
                            {allButtons.map((button) => (
                                <Button
                                    key={button.id}
                                    className={classes.button}
                                    href={baseUrl + button.href}
                                >
                                    {button.name}
                                </Button>
                            ))}
                        </div>
                    </div>
                </Grid>
            </Grid>
        </div>
    )
}

export default CommittedSection
